import { render } from "./ChatModal.vue?vue&type=template&id=5d80d5f9&scoped=true"
import script from "./ChatModal.vue?vue&type=script&lang=js"
export * from "./ChatModal.vue?vue&type=script&lang=js"

import "./ChatModal.vue?vue&type=style&index=0&id=5d80d5f9&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d80d5f9"]])

export default __exports__